import { Menu, MenuButton, MenuItem, MenuItems, RadioGroup } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axios from 'axios';
import GoogleMapReact from "google-map-react";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MdArrowForward, MdCopyright, MdOutlineVideocam, MdRadioButtonChecked, MdRadioButtonUnchecked } from 'react-icons/md';
import Slider from 'react-infinite-logo-slider';
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useNavigate } from 'react-router-dom';
import { videoUrlSinhala, videoUrlTamil, web_url } from '../constant';
import "./styles.css";

const Marker = ({ text }) => {
    const [hover, setHover] = useState(false);

    return (
        <div
            className="relative z-[9999] -translate-x-1/2 -translate-y-1/2"
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            <img src='images/location.svg' className='h-[20px] xl:h-[30px]' alt='location' />

            {hover && (
                <div className="absolute bottom-8 left-1/2 -translate-x-1/2 bg-black text-white text-[10px] xl:text-[13px] p-1 rounded-lg shadow-md w-[100px]">
                    {text}
                </div>
            )}
        </div>
    );
};

function Homepage() {
    const [language, setLanguage] = useState(() => {
        // const languageNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        // return languageNow;
        ""
    })
    const { t, i18n } = useTranslation();

    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    const navigate = useNavigate();

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const [openVideo, setOpenVideo] = useState(false);

    const handleCloseVideo = () => {
        setOpenVideo(false);
    };

    const handleClickOpenVideo = () => {
        setOpenVideo(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [open2, setOpen2] = useState(false);

    const handleClickOpen2 = () => {
        setOpen2(true);
    };

    const handleClose2 = () => {
        setOpen2(false);
    };

    const [open3, setOpen3] = useState(false);

    const handleClickOpen3 = () => {
        setOpen3(true);
    };

    const handleClose3 = () => {
        setOpen3(false);
    };


    const [letterDetails, setLetterDetails] = useState({
        totalLetters: 1000,
        averageWord: 1000,
        totalWords: 1000
    });



    const defaultProps = {
        center: {
            lat: 6.9271, // Latitude for Colombo, Sri Lanka
            lng: 79.8612 // Longitude for Colombo, Sri Lanka
        },
        zoom: 9
    };

    const [xlButtonSelected, setXlButtonSelected] = useState(0);

    const [isHovered, setIsHovered] = useState(false);

    let intervalId = null;

    useEffect(() => {
        if (isHovered) {
            clearInterval(intervalId);
            return;
        }

        intervalId = setInterval(() => {
            setXlButtonSelected(prev => (prev + 1) % 4);
        }, 3000);

        return () => clearInterval(intervalId);
    }, [isHovered]);

    const provinceMapping = {
        // Western Province
        "Colombo": "western",
        "Gampaha": "western",
        "Kalutara": "western",

        // Central Province
        "Kandy": "central",
        "Matale": "central",
        "Nuwara Eliya": "central",

        // Southern Province
        "Galle": "southern",
        "Matara": "southern",
        "Hambantota": "southern",

        // Northern Province
        "Jaffna": "northern",
        "Kilinochchi": "northern",
        "Mannar": "northern",
        "Vavuniya": "northern",
        "Mullaitivu": "northern",

        // Eastern Province
        "Trincomalee": "eastern",
        "Batticaloa": "eastern",
        "Ampara": "eastern",

        // North Western Province
        "Kurunegala": "northWestern",
        "Puttalam": "northWestern",

        // North Central Province
        "Anuradhapura": "northCentral",
        "Polonnaruwa": "northCentral",

        // Uva Province
        "Badulla": "uva",
        "Monaragala": "uva",

        // Sabaragamuwa Province
        "Ratnapura": "sabaragamuwa",
        "Kegalle": "sabaragamuwa"
    };

    const [totalSchools, setTotalSchools] = useState(0);
    const [totalTeacher, setTotalTeachers] = useState(0);
    const [totalStudent, setTotalStudents] = useState(0);

    const [districtSchool, setDistrictSchools] = useState({
        western: [0, 0, 0], // students,percentage
        northern: [0, 0, 0],
        eastern: [0, 0, 0],
        southern: [0, 0, 0],
        central: [0, 0, 0],
        northWestern: [0, 0, 0],
        uva: [0, 0, 0],
        sabaragamuwa: [0, 0, 0],
        northCentral: [0, 0, 0]
    });

    const [loadingSchool, setLoadingSchool] = useState(false);
    const [loadingSentiment, setLoadingSentiment] = useState(false);
    const [loadingTeachers, setLoadingTeachers] = useState(false);
    const [loadingEmailDetails, setLoadingEmailDetails] = useState(false);

    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
    };

    const [locations, setLocations] = useState(
        []
    );

    useEffect(() => {
        setLoadingTeachers(true);

        axios.get(`${web_url}/api/auth/stats/district`).then((res) => {
            const updatedCounts = { ...districtSchool };
            let totalTeachers = res.data.totalTeachers || 0;
            let totalStudents = res.data.totalStudents || 0;

            const districtData = res.data.district;

            Object.keys(districtData).forEach(district => {
                const entry = districtData[district];
                const province = provinceMapping[district];

                if (province) {
                    // Update school count
                    updatedCounts[province][2] += entry.schools || 0;

                    // Update student count
                    updatedCounts[province][0] += entry.students || 0;
                }
            });

            // Optionally calculate percentage of students per province
            Object.keys(updatedCounts).forEach(province => {
                const studentsInProvince = updatedCounts[province][0];
                const percentage = totalStudents > 0 ? ((studentsInProvince / totalStudents) * 100).toFixed(2) : "0.00";
                updatedCounts[province][1] = parseFloat(percentage);
            });

            setDistrictSchools(updatedCounts);
            setTotalStudents(totalStudents);
            setTotalTeachers(totalTeachers);
            setLoadingTeachers(false);
        }).catch((err) => {
            if (err.response) {
                if (err.response.data.error) {
                    handleClickOpenError(err.response.data.error);
                } else if (err.response.data.message) {
                    handleClickOpenError(err.response.data.message);
                } else if (err.response.data.token) {
                    handleClickOpenError(err.response.data.token);
                } else {
                    handleClickOpenError("An unknown error occurred");
                }
            }
            setLoadingTeachers(false);
        });
    }, [web_url]);


    useEffect(() => {
        setLoadingSchool(true)
        axios.get(`${web_url}/api/auth/schools`).then((res) => {

            res.data.forEach(entry => {
                const province = provinceMapping[entry.district];
                if (province) {
                    try {
                        setLocations((prev) => ([...prev, { lat: entry.latitude, lng: entry.longitude, s_name: entry.name }]))
                    } catch (e) {
                        // console.log("e1", e);
                        setLocations([
                            { lat: 6.9271, lng: 79.8612, s_name: "Colombo Royal College" },
                            { lat: 7.2906, lng: 80.6337, s_name: "Colombo Royal College" },
                            { lat: 6.0535, lng: 80.221, s_name: "Colombo Royal College" }
                        ])
                    }
                }

            });

            let total = res.data.length;
            setTotalSchools(total);
            setLoadingSchool(false);
        }).catch((err) => {
            // console.log('err', err);

            if (err.response) {
                // console.log(err.response)
                if (err.response.data.error) {
                    handleClickOpenError(err.response.data.error);
                } else if (err.response.data.message) {
                    handleClickOpenError(err.response.data.message);
                } else if (err.response.data.token) {
                    handleClickOpenError(err.response.data.token);
                } else {
                    handleClickOpenError("An unknown error occured");
                }

            }
            setLoadingSchool(false);
        })
    }, [web_url]);

    const [sentiment, setSentiment] = useState({
        positive: 100,
        negative: 30,
        neutral: 40
    });

    useEffect(() => {
        setLoadingSentiment(true)
        axios.get(`${web_url}/api/email-threads/sentiment`).then((res) => {
            try {
                setSentiment({
                    positive: (res.data.average_pos * 100).toFixed(2),
                    negative: (res.data.average_neg * 100).toFixed(2),
                    neutral: (res.data.average_neu * 100).toFixed(2)
                })
            } catch (e) {
                // console.log("e5", e);

                setSentiment({
                    positive: 100,
                    negative: 30,
                    neutral: 40
                })
            }
            setLoadingSentiment(false);
        }).catch((err) => {
            // console.log('err', err);

            if (err.response) {
                // console.log(err.response)
                if (err.response.data.error) {
                    handleClickOpenError(err.response.data.error);
                } else if (err.response.data.message) {
                    handleClickOpenError(err.response.data.message);
                } else if (err.response.data.token) {
                    handleClickOpenError(err.response.data.token);
                } else {
                    handleClickOpenError("An unknown error occured");
                }

            }
            setLoadingSentiment(false);
        })
    }, [web_url]);

    useEffect(() => {
        setLoadingEmailDetails(true)
        axios.get(`${web_url}/api/email-threads/stats`).then((res) => {
            try {
                setLetterDetails({
                    totalLetters: res.data.totalLettersSentThisWeek,
                    averageWord: res.data.averageWordCountPerLetter,
                    totalWords: res.data.totalWordsTranslatedThisMonth
                });
            } catch (e) {
                // console.log("e6", e);

                setLetterDetails({
                    totalLetters: 1000,
                    averageWord: 1000,
                    totalWords: 1000
                });
            }
            setLoadingEmailDetails(false);
        }).catch((err) => {
            // console.log('err', err);

            if (err.response) {
                // console.log(err.response)
                if (err.response.data.error) {
                    handleClickOpenError(err.response.data.error);
                } else if (err.response.data.message) {
                    handleClickOpenError(err.response.data.message);
                } else if (err.response.data.token) {
                    handleClickOpenError(err.response.data.token);
                } else {
                    handleClickOpenError("An unknown error occured");
                }

            }
            setLoadingEmailDetails(false);
        })
    }, [web_url]);

    const [loadedImages, setLoadedImages] = useState(0);

    const [showLoadingIndicator, setShowingLoadingIndicator] = useState(false);

    useEffect(() => {
        if (loadingSchool || loadingSentiment || loadingTeachers || loadingEmailDetails || loadedImages < 7) {
            setShowingLoadingIndicator(true);
        } else {
            setShowingLoadingIndicator(false);
        }

    }, [loadingSchool, loadingSentiment, loadingTeachers, loadingEmailDetails, loadedImages])

    // console.log(window.innerWidth, window.innerHeight);

    const [openLangSelectInitial, setOpenLangSelectInitial] = useState(false);

    useEffect(() => {
        if (!showLoadingIndicator) {
            setOpenLangSelectInitial(true);
        } else {
            setOpenLangSelectInitial(false);
        }
    }, [showLoadingIndicator])

    const [videoLanguage, setVideoLanguage] = useState('')
    const [openVideoLangDialog, setOpenVideoLangDialog] = useState(false);
    const [videoLangError, setVideoLangError] = useState(false);

    return (
        <>
            {
                showLoadingIndicator &&
                <div className='h-screen w-screen flex justify-center items-center overflow-x-hidden overflow-y-hidden bg-white'>
                    <img src="/images/logo.svg" alt="logo" className="blinking-logo" />
                </div>
            }

            <div className={`${showLoadingIndicator ? "hidden" : ""} min-h-screen ${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} bg-white w-screen flex flex-col justify-center md:items-center overflow-x-hidden`}>
                <Menu as="div" className={`${showLoadingIndicator ? "none" : ""} xl:hidden absolute top-0 right-0 m-[10px] text-left items-right`}>
                    <div>
                        <MenuButton className={`${showLoadingIndicator ? "hidden" : ""} inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50`}>
                            {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                            <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400" />
                        </MenuButton>
                    </div>

                    <MenuItems
                        transition
                        className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                    >
                        <div className="py-1">
                            <MenuItem>
                                <button
                                    className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                    onClick={() => {
                                        setLanguage("English");
                                        changeLanguage('en')
                                    }}
                                >
                                    English
                                </button>
                            </MenuItem>
                            <MenuItem>
                                <button
                                    className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                    onClick={() => {
                                        setLanguage("Sinhala");
                                        changeLanguage('si')
                                    }}
                                >
                                    සිංහල
                                </button>
                            </MenuItem>
                            <MenuItem>
                                <button
                                    className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                    onClick={() => {
                                        setLanguage("Tamil");
                                        changeLanguage('ta')
                                    }}
                                >
                                    தமிழ்
                                </button>
                            </MenuItem>
                        </div>
                    </MenuItems>
                </Menu>

                <div className={`${showLoadingIndicator ? "none" : "xl:block"} hidden xl:block h-[80px] 2xl:h-[100px] w-full fixed top-[40px] z-30 pl-[200px] pr-[200px]`}>
                    <div className='h-full w-full flex items-center justify-between px-[20px] bg-white bg-opacity-[90%] rounded-[20px]'>
                        <div className='flex items-center justify-start gap-[10px]'>
                            <img src="/images/logo.svg" alt="logo" className='h-[60px] 2xl:h-[80px]' />
                            <div className='flex flex-col items-start justify-center'>
                                <p className={`font-[500] ${i18n.language === "en" ? "text-[25px] 2xl:text-[30px]" : (i18n.language === "si" ? "text-[19px] 2xl:text-[24px]" : "text-[18px] 2xl:text-[24px]")} text-black leading-none`}>{t('t1')}</p>
                                <p className={` font-[400] ${i18n.language === "en" ? "text-[14px] 2xl:text-[17px] mt-[5px]" : "text-[12px] 2xl:text-[15px] mt-[8px]"} text-black leading-none`}>{t('t294')}</p>
                            </div>
                        </div>
                        <div className='flex items-center justify-start gap-[10px]'>
                            <button onClick={() => navigate('/user/boarding')} className={`h-[40px] 2xl:h-[60px] w-[150px] 2xl:w-[190px] ${i18n.language === "en" ? "text-[17px] 2xl:text-[23px]" : i18n.language === "si" ? "text-[14px] 2xl:text-[18px]" : "text-[14px] 2xl:text-[19px]"} text-white font-bold rounded-lg bg-gradient-to-r from-[#FFA803] to-[#FFD12E]`}>{t('t446')}</button>
                            <Menu as="div" className={`${showLoadingIndicator ? "none" : ""} relative m-[10px] text-left items-right`}>
                                <div>
                                    <MenuButton className={`${showLoadingIndicator ? "hidden" : ""} inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-[15px] h-[40px] 2xl:h-[60px] py-[10px] 2xl:py-[18px] text-sm 2xl:text-[20px] font-semibold text-[#CE8500] shadow-sm ring-1 ring-inset ring-[#EFAE03] hover:bg-gray-50`}>
                                        {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                                        <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 text-[#CE8500]" />
                                    </MenuButton>
                                </div>

                                <MenuItems
                                    transition
                                    className="px-[10px] py-[10px] absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                                >
                                    <div className="py-1">
                                        <MenuItem>
                                            <button
                                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 bg-gray-100 hover:bg-gray-300 focus:bg-gray-100 focus:text-gray-900 focus:outline-none rounded-lg "
                                                onClick={() => {
                                                    setLanguage("English");
                                                    changeLanguage('en')
                                                }}
                                            >
                                                English
                                            </button>
                                        </MenuItem>
                                        <MenuItem>
                                            <button
                                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 bg-gray-100 hover:bg-gray-300 focus:bg-gray-100 focus:text-gray-900 focus:outline-none rounded-lg mt-[5px]"
                                                onClick={() => {
                                                    setLanguage("Sinhala");
                                                    changeLanguage('si')
                                                }}
                                            >
                                                සිංහල
                                            </button>
                                        </MenuItem>
                                        <MenuItem>
                                            <button
                                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 bg-gray-100 hover:bg-gray-300 focus:bg-gray-100 focus:text-gray-900 focus:outline-none rounded-lg mt-[5px]"
                                                onClick={() => {
                                                    setLanguage("Tamil");
                                                    changeLanguage('ta')
                                                }}
                                            >
                                                தமிழ்
                                            </button>
                                        </MenuItem>
                                    </div>
                                </MenuItems>
                            </Menu>
                        </div>
                    </div>
                </div>

                <div className={`${showLoadingIndicator ? "none" : "xl:block"} hidden h-screen min-h-[670px] 2xl:min-h-[950px] w-screen`}>
                    <div className="absolute inset-0 bg-bghome bg-no-repeat bg-cover h-screen min-h-[670px] 2xl:min-h-[950px]" />
                    <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(19,19,19,0.7)_0%,transparent_20%)] h-screen min-h-[670px] 2xl:min-h-[950px]" />
                    <div className="absolute inset-0 bg-[linear-gradient(to_top_right,rgba(19,19,19,1)_0%,rgba(19,19,19,0.4)_50%,transparent_90%)] h-screen min-h-[670px] 2xl:min-h-[950px]" />
                    <div className="absolute inset-0 bg-[linear-gradient(to_bottom_right,rgba(19,19,19,0.8)_0%,rgba(19,19,19,0.4)_50%,transparent_90%)] h-screen min-h-[670px] 2xl:min-h-[950px]" />


                    <div className='h-full w-full relative z-10 pt-[200px] 2xl:pt-[300px]'>
                        <div className='flex flex-col items-start justify-center pl-[200px] col-span-3 pt-[100px] 2xl:pt-[200px]'>
                            <p className={`text-white font-bold text-left ${i18n.language === "en" ? "text-[80px] 2xl:text-[100px]" : (i18n.language === "si" ? "text-[60px] 2xl:text-[75px]" : "text-[50px] 2xl:text-[65px]")} leading-none`}>{t('t331')}</p>
                            <p className={`text-white font-bold text-left ${i18n.language === "en" ? "text-[80px] 2xl:text-[100px] mt-[15px]" : (i18n.language === "si" ? "text-[60px] 2xl:text-[75px] mt-[25px]" : "text-[50px] 2xl:text-[65px] mt-[15px]")} leading-none `}>{t('t332')}</p>
                            <p className={`font-[500] text-white/60 text-left ${i18n.language === "en" ? "text-[20px] 2xl:text-[30px] mt-[20px]" : (i18n.language === "si" ? "text-[17px] 2xl:text-[25px] mt-[25px]" : "text-[15px] 2xl:text-[23px] mt-[25px] 2xl:mt-[35px]")} leading-none`}>{t('t333')}</p>
                            <p className={`text-white/60 font-[500] text-left ${i18n.language === "en" ? "text-[20px] 2xl:text-[30px] mt-[3px]" : (i18n.language === "si" ? "text-[17px] 2xl:text-[25px] mt-[7px]" : "text-[15px] 2xl:text-[23px] mt-[7px]")} leading-none`}>{t('t334')}</p>
                            <div className='flex gap-[20px]'>
                                <button onClick={() => navigate('/user/boarding')} className={`mt-[40px] py-[5px] w-[150px] 2xl:w-[200px] ${i18n.language === "en" ? "text-[17px] 2xl:text-[20px]" : (i18n.language === "si" ? "text-[15px] 2xl:text-[20px]" : "text-[15px] 2xl:text-[20px]")} text-white font-bold rounded-lg bg-gradient-to-r from-[#FFA803] to-[#FFD12E]`}>{t('t446')}</button>
                                <button onClick={() => {
                                    setVideoLangError(false);
                                    setOpenVideoLangDialog(true);
                                }} className={`flex items-center justify-center mt-[40px] py-[5px] w-[180px] 2xl:w-[220px] gap-[10px] ${i18n.language === "en" ? "text-[17px] 2xl:text-[20px]" : (i18n.language === "si" ? "text-[15px] 2xl:text-[22px]" : "text-[15px] 2xl:text-[20px]")} text-[#CE8500] font-bold rounded-lg bg-transparent border border-[#EFAE03] border-[2px]`}>
                                    <MdOutlineVideocam className="text-[#CE8500]" size={40} />
                                    {t('t447')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>


                <div className={`hidden ${showLoadingIndicator ? "none" : "xl:grid grid-cols-2"} w-full mt-[60px] gap-[20px] 2xl:gap-[40px] `}>
                    {/* <div className='flex flex-col items-center justify-end'>
                        <img onLoad={() => setLoadedImages(prev => prev + 1)} src='images/imgpc.webp' className='h-[400px] 2xl:h-[500px]' alt='student' />
                        <img onLoad={() => setLoadedImages(prev => prev + 1)} src='images/imgpc.webp' className='h-[400px] 2xl:h-[500px]' alt='student' />
                    </div> */}

                    <div className='relative flex flex-col items-center justify-start'>
                        <img onLoad={() => setLoadedImages(prev => prev + 1)} src='images/imgpc_back.webp' className='h-[300px] 2xl:h-[400px] object-cover rounded-lg' alt='student' />
                        <img onLoad={() => setLoadedImages(prev => prev + 1)} src='images/imgpc.webp' className='absolute top-[20%] left-[40%] h-[300px] 2xl:h-[400px] z-10 rounded-lg' alt='student' />
                    </div>
                    <div className='flex flex-col items-start justify-start pr-[200px] 2xl:pr-[230px]'>
                        <p className={`font-bold ${i18n.language === "en" ? "text-[26px] 2xl:text-[32px]" : (i18n.language === "si" ? "text-[22px] 2xl:text-[32px]" : "text-[22px] 2xl:text-[32px]")} pb-[10px]`}>{t('t335')}</p>
                        <p className={`${i18n.language === "en" ? "text-[13px] 2xl:text-[17px]" : (i18n.language === "si" ? "text-[12px] 2xl:text-[15px]" : "text-[11px] 2xl:text-[15px]")} pb-[20px] text-justify text-[#686868]`}>{t('t336')}<br /><br />{t('t337')} <br /><br />{t('t338')}</p>
                    </div>
                </div>

                <div className={`hidden ${showLoadingIndicator ? "none" : "xl:flex"} items-center justify-center gap-[40px] mt-[70px] 2xl:mt-[100px]`}

                >
                    <button
                        onClick={() => setXlButtonSelected(0)} className={` ${xlButtonSelected === 0 ? 'bg-gradient-to-r from-[#FFA803] to-[#FFD12E]' : 'bg-[#F5E8C7]'} w-[200px] 2xl:w-[240px] px-[10px] py-[10px] 2xl:px-[10px] 2xl:py-[13px]  text-[13px] 2xl:text-[17px] text-black  rounded-full `}>{t('t300')}</button>
                    <button
                        onClick={() => setXlButtonSelected(1)} className={`${xlButtonSelected === 1 ? 'bg-gradient-to-r from-[#FFA803] to-[#FFD12E]' : 'bg-[#F5E8C7]'} w-[200px] 2xl:w-[240px]  px-[20px] py-[10px] 2xl:px-[10px] 2xl:py-[13px]  text-[13px] 2xl:text-[17px] text-black  rounded-full `}>{t('t308')}</button>
                    <button
                        onClick={() => setXlButtonSelected(2)} className={`${xlButtonSelected === 2 ? 'bg-gradient-to-r from-[#FFA803] to-[#FFD12E]' : 'bg-[#F5E8C7]'} w-[200px] 2xl:w-[240px] px-[20px] py-[10px] 2xl:px-[15px] 2xl:py-[13px]  text-[13px] 2xl:text-[17px] text-black  rounded-full `}>{t('t319')} </button>
                    <button
                        onClick={() => setXlButtonSelected(3)} className={`${xlButtonSelected === 3 ? 'bg-gradient-to-r from-[#FFA803] to-[#FFD12E]' : 'bg-[#F5E8C7]'} w-[200px] 2xl:w-[240px]  px-[20px] py-[10px] 2xl:px-[10px] 2xl:py-[13px]  text-[13px] 2xl:text-[17px] text-black  rounded-full `}>{t('t324')}</button>
                </div>

                <div
                    className={`${showLoadingIndicator ? "none" : "xl:block"}`}
                    onMouseEnter={() => setIsHovered(true)}  // Pause auto-change
                    onMouseLeave={() => setIsHovered(false)} // Resume auto-change
                >
                    {
                        xlButtonSelected === 0 &&
                        <div className={`hidden ${showLoadingIndicator ? "none" : "xl:flex"} items-center justify-center`}>
                            <div className='mt-[20px] bg-[#FAC236] rounded-xl mx-[10px] px-[20px] py-[10px] bg-opacity-20 border border-[#FAC236] border-[2px] w-[1000px] 2xl:w-[1200px] '>
                                <div className='flex flex-col items-center justify-center mb-[7px]'>
                                    <p className='text-black font-bold text-[18px] 2xl:text-[20px] pl-[10px]'>🎓 {t('t301')}</p>
                                </div>
                                <div className='flex items-center justify-center gap-[20px] pb-[10px]'>
                                    <p className='text-black text-[13px] 2xl:text-[22px]'>{t('t302')} <span className='text-[15px] 2xl:text-[24px] font-bold'>{totalSchools}</span></p>
                                    <p className='text-black text-[13px] 2xl:text-[22px]'>{t('t303')} <span className='text-[15px] 2xl:text-[24px] font-bold'>{totalStudent}</span></p>
                                    <p className='text-black text-[13px] 2xl:text-[22px]'>{t('t304')} <span className='text-[15px] 2xl:text-[24px] font-bold'>{totalTeacher}</span></p>
                                </div>

                                <div className="h-[170px] 2xl:h-[300px] w-full relative">
                                    <GoogleMapReact
                                        bootstrapURLKeys={{ key: "AIzaSyB_TkkxZRCk_V6-k1nfYm-jhfvWNdGG2SA" }}
                                        defaultCenter={defaultProps.center}
                                        defaultZoom={defaultProps.zoom}
                                    >
                                        {locations.map((location, index) => (
                                            <Marker key={index} lat={location.lat} lng={location.lng} text={location.s_name} />
                                        ))}
                                    </GoogleMapReact>
                                </div>
                            </div>
                        </div>
                    }

                    {
                        xlButtonSelected === 1 &&
                        <div className={`hidden ${showLoadingIndicator ? "none" : "xl:grid grid-cols-3"}  gap-[10px] bg-[#FAC236] mt-[30px] bg-[#FAC236] rounded-xl mx-[10px] px-[20px] pt-[5px] 2xl:pt-[20px] bg-opacity-20 border border-[#FAC236] border-[2px] w-[1000px] 2xl:w-[1200px] h-[250px] 2xl:h-[390px] `}>
                            <div >
                                <p className={`text-black ${i18n.language === "en" ? "text-[13px] 2xl:text-[24px]" : (i18n.language === "si" ? "text-[11px] 2xl:text-[21px]" : "text-[11px] 2xl:text-[17px]")} pt-[5px]`}>{t('t309')} {districtSchool.western[0]} {t('t318')} ({districtSchool.western[1]}%) <br /> {districtSchool.western[2]} {districtSchool.western[2] > 1 ? t('t33_1') : t('t33')}</p>
                                <progress value={districtSchool.western[1]} max={100} className='w-full custom-progress-bar' />
                            </div>
                            <div >
                                <p className={`text-black ${i18n.language === "en" ? "text-[13px] 2xl:text-[24px]" : (i18n.language === "si" ? "text-[11px] 2xl:text-[21px]" : "text-[11px] 2xl:text-[17px]")} pt-[5px]`}>{t('t310')} {districtSchool.eastern[0]} {t('t318')} ({districtSchool.eastern[1]}%) <br /> {districtSchool.eastern[2]} {districtSchool.eastern[2] > 1 ? t('t33_1') : t('t33')}</p>
                                <progress value={districtSchool.eastern[1]} max={100} className='w-full custom-progress-bar' />
                            </div>
                            <div >
                                <p className={`text-black ${i18n.language === "en" ? "text-[13px] 2xl:text-[24px]" : (i18n.language === "si" ? "text-[11px] 2xl:text-[21px]" : "text-[11px] 2xl:text-[17px]")} pt-[5px]`}>{t('t311')} {districtSchool.northern[0]} {t('t318')} ({districtSchool.northern[1]}%) <br /> {districtSchool.northern[2]} {districtSchool.northern[2] > 1 ? t('t33_1') : t('t33')}</p>
                                <progress value={districtSchool.northern[1]} max={100} className='w-full custom-progress-bar' />
                            </div>
                            <div >
                                <p className={`text-black ${i18n.language === "en" ? "text-[13px] 2xl:text-[24px]" : (i18n.language === "si" ? "text-[11px] 2xl:text-[21px]" : "text-[11px] 2xl:text-[17px]")} pt-[5px]`}>{t('t312')} {districtSchool.southern[0]} {t('t318')} ({districtSchool.southern[1]}%) <br /> {districtSchool.southern[2]} {districtSchool.southern[2] > 1 ? t('t33_1') : t('t33')}</p>
                                <progress value={districtSchool.southern[1]} max={100} className='w-full custom-progress-bar' />
                            </div>
                            <div >
                                <p className={`text-black ${i18n.language === "en" ? "text-[13px] 2xl:text-[24px]" : (i18n.language === "si" ? "text-[11px] 2xl:text-[21px]" : "text-[11px] 2xl:text-[17px]")} pt-[5px]`}>{t('t313')} {districtSchool.central[0]} {t('t318')} ({districtSchool.central[1]}%) <br /> {districtSchool.central[2]} {districtSchool.central[2] > 1 ? t('t33_1') : t('t33')}</p>
                                <progress value={districtSchool.central[1]} max={100} className='w-full custom-progress-bar' />
                            </div>
                            <div >
                                <p className={`text-black ${i18n.language === "en" ? "text-[13px] 2xl:text-[24px]" : (i18n.language === "si" ? "text-[11px] 2xl:text-[21px]" : "text-[11px] 2xl:text-[17px]")} pt-[5px]`}>{t('t314')} {districtSchool.northCentral[0]} {t('t318')} ({districtSchool.northCentral[1]}%) <br /> {districtSchool.northCentral[2]} {districtSchool.northCentral[2] > 1 ? t('t33_1') : t('t33')}</p>
                                <progress value={districtSchool.northCentral[1]} max={100} className='w-full custom-progress-bar' />
                            </div>
                            <div >
                                <p className={`text-black ${i18n.language === "en" ? "text-[13px] 2xl:text-[24px]" : (i18n.language === "si" ? "text-[11px] 2xl:text-[21px]" : "text-[11px] 2xl:text-[17px]")} pt-[5px]`}>{t('t315')} {districtSchool.northWestern[0]} {t('t318')} ({districtSchool.northWestern[1]}%) <br /> {districtSchool.northWestern[2]} {districtSchool.northWestern[2] > 1 ? t('t33_1') : t('t33')}</p>
                                <progress value={districtSchool.northWestern[1]} max={100} className='w-full custom-progress-bar' />
                            </div>
                            <div >
                                <p className={`text-black ${i18n.language === "en" ? "text-[13px] 2xl:text-[24px]" : (i18n.language === "si" ? "text-[11px] 2xl:text-[21px]" : "text-[11px] 2xl:text-[17px]")} pt-[5px]`}>{t('t316')} {districtSchool.uva[0]} {t('t318')} ({districtSchool.uva[1]}%) <br /> {districtSchool.uva[2]} {districtSchool.uva[2] > 1 ? t('t33_1') : t('t33')}</p>
                                <progress value={districtSchool.uva[1]} max={100} className='w-full custom-progress-bar' />
                            </div>
                            <div >
                                <p className={`text-black ${i18n.language === "en" ? "text-[13px] 2xl:text-[24px]" : (i18n.language === "si" ? "text-[11px] 2xl:text-[21px]" : "text-[11px] 2xl:text-[17px]")} pt-[5px]`}>{t('t317')} {districtSchool.sabaragamuwa[0]} {t('t318')} ({districtSchool.sabaragamuwa[1]}%) <br /> {districtSchool.sabaragamuwa[2]} {districtSchool.sabaragamuwa[2] > 1 ? t('t33_1') : t('t33')}</p>
                                <progress value={districtSchool.sabaragamuwa[1]} max={100} className='w-full custom-progress-bar' />
                            </div>
                        </div>
                    }

                    {
                        xlButtonSelected === 2 &&
                        <div className={`hidden ${showLoadingIndicator ? "none" : "xl:flex flex-col"}  items-center justify-center bg-[#FAC236] mt-[30px] bg-[#FAC236] rounded-xl mx-[10px] px-[20px] py-[20px] bg-opacity-20 border border-[#FAC236] border-[2px] w-[1000px] 2xl:w-[1200px] h-[250px] 2xl:h-[390px] `}>
                            <div >
                                <p className='text-black text-[18px] 2xl:text-[22px] pt-[20px] '>{t('t320')} <span className='text-[20px] 2xl:text-[22px] font-bold'>{letterDetails.totalLetters}</span></p>
                                {/* <p className='text-black text-[18px] 2xl:text-[22px] pt-[5px]'>{t('t321')} <span className='text-[20px] 2xl:text-[22px] font-bold'>{letterDetails.averageWord}</span> {t('t323')}</p> */}
                                <p className='text-black text-[18px] 2xl:text-[22px] pt-[5px] pb-[5px]'>{t('t322')} <span className='text-[20px] 2xl:text-[22px] font-bold'>{letterDetails.totalWords} </span>{t('t323')}</p>
                            </div>
                        </div>

                    }

                    {
                        xlButtonSelected === 3 &&
                        <div className={`hidden ${showLoadingIndicator ? "none" : "xl:block"}  bg-[#FAC236] mt-[30px] bg-[#FAC236] rounded-xl mx-[10px] px-[20px] py-[20px] bg-opacity-20 border border-[#FAC236] border-[2px] w-[1000px] 2xl:w-[1200px] h-[250px] 2xl:h-[390px] `}>
                            <div className='flex justify-evenly items-center mt-[20px] 2xl:mt-[100px]'>
                                <div className='flex flex-col items-center justify-center'>
                                    <img src='images/positive.svg' alt='positive' className='h-[70px] md:h-[90px]' />
                                    <p className='text-black text-[17px] md:text-[24px] lg:text-[25px] mt-[5px] font-bold'>{t('t325')}</p>
                                    <p className='text-black text-[17px] md:text-[24px] lg:text-[25px]'>{sentiment.positive} %</p>
                                </div>
                                <div className='flex flex-col items-center justify-center'>
                                    <img src='images/negative.svg' alt='negative' className='h-[70px] md:h-[90px]' />
                                    <p className='text-black text-[17px] md:text-[24px] lg:text-[25px] mt-[5px] font-bold'>{t('t326')}</p>
                                    <p className='text-black text-[17px] md:text-[24px] lg:text-[25px]'>{sentiment.negative} %</p>
                                </div>
                                <div className='flex flex-col items-center justify-center'>
                                    <img src='images/neutral.svg' alt='neutral' className='h-[70px] md:h-[90px]' />
                                    <p className='text-black text-[17px] md:text-[24px] lg:text-[25px] mt-[5px] font-bold'>{t('t327')}</p>
                                    <p className='text-black text-[17px] md:text-[24px] lg:text-[25px]'>{sentiment.neutral} %</p>
                                </div>
                            </div>
                        </div>

                    }
                </div>

                <div className={`hidden ${showLoadingIndicator ? "none" : "xl:flex"} items-center justify-center mt-[10px]`}>
                    {
                        xlButtonSelected === 0 ? <MdRadioButtonChecked /> : <MdRadioButtonUnchecked />
                    }
                    {
                        xlButtonSelected === 1 ? <MdRadioButtonChecked /> : <MdRadioButtonUnchecked />
                    }
                    {
                        xlButtonSelected === 2 ? <MdRadioButtonChecked /> : <MdRadioButtonUnchecked />
                    }
                    {
                        xlButtonSelected === 3 ? <MdRadioButtonChecked /> : <MdRadioButtonUnchecked />
                    }
                </div>


                <div className={`hidden ${showLoadingIndicator ? "none" : "xl:block"} mt-[60px] flex flex-col justify-center items-center pt-[20px] pb-[20px] 2xl:pt-[40px] 2xl:pb-[40px] bg-[#FAC236] w-screen `}>
                    <div className='mb-[20px] flex items-center justify-center'>
                        <p style={{ fontFamily: 'sans-serif' }} className='font-bold text-[20px] 2xl:text-[26px]'>{t('t306')}</p>
                    </div>
                    <div>
                        <Slider
                            width="240px"
                            duration={8}
                            pauseOnHover={true}
                            blurBorders={false}
                            blurBorderColor={'#fff'}
                        >
                            <Slider.Slide>
                                <div className='mx-[0px]'>
                                    <img src="images/logo_1.png" alt="any" className='h-[60px] ' />
                                </div>
                            </Slider.Slide>
                            <Slider.Slide>
                                <div className='ml-[50px]'>
                                    <img src="images/protonest.png" alt="any" className='h-[60px] ' />
                                </div>
                            </Slider.Slide>
                            <Slider.Slide>
                                <div className='mx-[0px]'>
                                    <img src="images/logo_2.png" alt="any" className='h-[55px] ' />
                                </div>
                            </Slider.Slide>
                            <Slider.Slide>
                                <div className='mx-[0px]'>
                                    <img src="images/logo_3.png" alt="any" className='h-[55px] ' />
                                </div>
                            </Slider.Slide>
                        </Slider>
                    </div>
                </div>

                <div className='w-full bg-[#F6F6F6] pb-[50px] hidden xl:block'>
                    <div className={`hidden ${showLoadingIndicator ? "none" : "xl:flex"} items-center justify-center mt-[70px]`}>
                        <p style={{ fontFamily: 'sans-serif' }} className=' font-bold text-[20px] 2xl:text-[27px]'>{t('t305')}</p>
                    </div>
                    <div className={`hidden ${showLoadingIndicator ? "none" : "xl:flex"} items-center justify-center mt-[20px] gap-[20px] 2xl:gap-[30px]`}>

                        <div className='flex flex-col bg-[#D9D9D9] items-center justify-center rounded-xl w-[170px] 2xl:w-[210px] h-[250px] 2xl:h-[330px]'>
                            <div className='h-[140px] w-[140px] 2xl:h-[170px] 2xl:w-[170px] bg-black rounded-xl'>
                                <img onLoad={() => setLoadedImages(prev => prev + 1)} src='images/r_img1.png' className='w-full h-full object-cover' alt='researcher' />
                            </div>
                            <p className='text-center text-[13px] 2xl:text-[18px] mt-[10px] font-bold'>Naveen Wickremeratne</p>
                            <p className='text-[13px] 2xl:text-[17px] pb-[10px] text-center mt-[3px]'>Monash University,<br /> Australia</p>
                        </div>
                        <div className='flex flex-col bg-[#D9D9D9] items-center justify-center rounded-xl w-[170px] 2xl:w-[210px] h-[250px] 2xl:h-[330px]'>
                            <div className='h-[140px] w-[140px] 2xl:h-[170px] 2xl:w-[170px] bg-black rounded-xl'>
                                <img onLoad={() => setLoadedImages(prev => prev + 1)} src='images/r_img4.jpg' className='w-full h-full object-cover' alt='researcher' />
                            </div>
                            <p className='text-[13px] 2xl:text-[18px] mt-[10px] font-bold'>Andreas Pondorfer</p>
                            <p className='text-[13px] 2xl:text-[17px] pb-[10px] text-center mt-[3px]'>Technical University of Munich, Germany</p>
                        </div>
                        <div className='flex flex-col bg-[#D9D9D9] items-center justify-center rounded-xl w-[170px] 2xl:w-[210px] h-[250px] 2xl:h-[330px]'>
                            <div className='h-[140px] w-[140px] 2xl:h-[170px] 2xl:w-[170px] bg-black rounded-xl mt-[10px]'>
                                <img onLoad={() => setLoadedImages(prev => prev + 1)} src='images/r_img6.jpg' className='w-full h-full object-cover' alt='researcher' />
                            </div>
                            <p className='text-[13px] 2xl:text-[18px] mt-[10px] font-bold'>Matthias Sutter</p>
                            <p className='text-[13px] 2xl:text-[17px] pb-[5px] text-center mt-[3px]'>Max Planck Institute for Research on Collective Goods, Germany</p>
                        </div>
                        <div className='flex flex-col bg-[#D9D9D9] items-center justify-center rounded-xl w-[170px] 2xl:w-[210px] h-[250px] 2xl:h-[330px]'>
                            <div className='h-[140px] w-[140px] 2xl:h-[170px] 2xl:w-[170px] bg-black rounded-xl'>
                                <img onLoad={() => setLoadedImages(prev => prev + 1)} src='images/r_img2.jpg' className='w-full h-full object-cover' alt='researcher' />
                            </div>
                            <p className='text-center text-[13px] 2xl:text-[18px] mt-[10px] font-bold'>Bandula Thrimavithana</p>
                            <p className='text-[13px] 2xl:text-[17px] pb-[10px] text-center mt-[3px]'>Center for Social Change (CSC),<br />Sri Lanka</p>
                        </div>
                        <div className='flex flex-col bg-[#D9D9D9] items-center justify-center rounded-xl w-[170px] 2xl:w-[210px] h-[250px] 2xl:h-[330px]'>
                            <div className='h-[140px] w-[140px] 2xl:h-[170px] 2xl:w-[170px] bg-black rounded-xl'>
                                <img onLoad={() => setLoadedImages(prev => prev + 1)} src='images/r_img5.jpg' className='w-full h-full object-cover' alt='researcher' />
                            </div>
                            <p className='text-[13px] 2xl:text-[18px] mt-[10px] font-bold'>Thusitha Siriwardana</p>
                            <p className='text-[13px] 2xl:text-[17px] pb-[10px] text-center mt-[3px]'>Center for Social Change (CSC), <br />Sri Lanka</p>
                        </div>
                        <div className='flex flex-col bg-[#D9D9D9] items-center justify-center rounded-xl w-[170px] 2xl:w-[210px] h-[250px] 2xl:h-[330px]'>
                            <div className='h-[140px] w-[140px] 2xl:h-[170px] 2xl:w-[170px] bg-black rounded-xl'>
                                <img onLoad={() => setLoadedImages(prev => prev + 1)} src='images/r_img3.png' className='w-full h-full object-cover' alt='researcher' />
                            </div>
                            <p className='text-[13px] 2xl:text-[18px] mt-[10px] font-bold'>Nuwan Walasmullage</p>
                            <p className='text-[13px] 2xl:text-[17px] pb-[10px] text-center mt-[3px]'>Social Vision Survey<br />Institute,Sri Lanka</p>
                        </div>
                    </div>
                </div>

                <div className={`hidden ${showLoadingIndicator ? "none" : "xl:block"} mt-[30px] flex flex-col justify-center items-center pt-[20px] pb-[30px] 2xl:pt-[40px] 2xl:pb-[40px] w-screen`}>
                    <div className='mb-[40px] flex items-center justify-center'>
                        <p style={{ fontFamily: 'sans-serif' }} className='font-bold text-[20px] 2xl:text-[26px]'>{t('t307')}</p>
                    </div>
                    <div>
                        <Slider
                            width="280px"
                            duration={20}
                            pauseOnHover={true}
                            blurBorders={false}
                            blurBorderColor={'#fff'}
                        >
                            <Slider.Slide>
                                <img src="images/imc3.png" alt="any" className='w-[230px]' />
                            </Slider.Slide>
                            <Slider.Slide>
                                <img src="images/imc4.png" alt="any2" className='w-[230px]' />
                            </Slider.Slide>
                            <Slider.Slide>
                                <img src="images/imc3.png" alt="any3" className='w-[230px]' />
                            </Slider.Slide>
                            <Slider.Slide>
                                <img src="images/imc4.png" alt="any" className='w-[230px]' />
                            </Slider.Slide>
                            <Slider.Slide>
                                <img src="images/imc3.png" alt="any2" className='w-[230px]' />
                            </Slider.Slide>
                            <Slider.Slide>
                                <img src="images/imc4.png" alt="any3" className='w-[230px]' />
                            </Slider.Slide>
                        </Slider>
                    </div>

                    <div className='mt-[30px]'>
                        <Slider
                            width="280px"
                            duration={25}
                            pauseOnHover={true}
                            blurBorders={false}
                            blurBorderColor={'#fff'}
                        >
                            <Slider.Slide>
                                <img src="images/imc3.png" alt="any" className='w-[230px]' />
                            </Slider.Slide>
                            <Slider.Slide>
                                <img src="images/imc4.png" alt="any2" className='w-[230px]' />
                            </Slider.Slide>
                            <Slider.Slide>
                                <img src="images/imc3.png" alt="any3" className='w-[230px]' />
                            </Slider.Slide>
                            <Slider.Slide>
                                <img src="images/imc4.png" alt="any" className='w-[230px]' />
                            </Slider.Slide>
                            <Slider.Slide>
                                <img src="images/imc3.png" alt="any2" className='w-[230px]' />
                            </Slider.Slide>
                            <Slider.Slide>
                                <img src="images/imc4.png" alt="any3" className='w-[230px]' />
                            </Slider.Slide>
                        </Slider>
                    </div>
                </div>

                <div className={`hidden ${showLoadingIndicator ? "none" : "xl:grid grid-cols-2"} w-screen h-[300px] 2xl:h-[350px] bg-[#1E1E1E] mt-[70px] 2xl:mt-[90px]`}> {/* bg-[#F8F9FF] */}
                    <div className='flex items-center justify-center gap-[30px]'>
                        <img src="/images/logo.svg" className="h-[120px] 2xl:h-[180px]" alt='logo' />
                        <div className='flex flex-col item-center justify-center'>
                            <p className={`text-[#F1F6FB] text-left ${i18n.language === "en" ? "text-[30px] 2xl:text-[40px]" : (i18n.language === "si" ? "text-[22px] 2xl:text-[34px]" : "text-[18px] 2xl:text-[26px]")}  font-bold `}>{t('t1')}</p>
                            <p className={`text-[rgba(241,246,251,0.65)] text-left ${i18n.language === "en" ? "text-[15px] 2xl:text-[23px]" : (i18n.language === "si" ? "text-[11px] 2xl:text-[17px]" : "text-[11px] 2xl:text-[15px]")}`}>{t('t294')}</p>
                        </div>
                    </div>
                    <div className='flex items-start justify-center mt-[80px] gap-[80px] 2xl:gap-[120px]'>
                        <div className={`flex flex-col items-start justify-start w-[200px] ${i18n.language === "en" ? "gap-[0px]" : (i18n.language === "si" ? "gap-[3px]" : "gap-[3px]")}`}>
                            <p className={`text-left ${i18n.language === "en" ? "text-[18px] 2xl:text-[20px]" : (i18n.language === "si" ? "text-[15px] 2xl:text-[20px]" : "text-[13px] 2xl:text-[18px]")} text-[#F1F6FB] font-bold`}>{t('t339')}</p>
                            <p onClick={handleClickOpen3} className={`text-left mt-[20px] ${i18n.language === "en" ? "text-[14px] 2xl:text-[16px]" : (i18n.language === "si" ? "text-[12px] 2xl:text-[16px]" : "text-[11px] 2xl:text-[14px]")} text-[rgba(241,246,251,0.65)] cursor-pointer hover:underline`}>{t('t328')}</p>
                            <p onClick={handleClickOpen2} className={`text-left mt-[5px] ${i18n.language === "en" ? "text-[14px] 2xl:text-[16px]" : (i18n.language === "si" ? "text-[12px] 2xl:text-[16px]" : "text-[11px] 2xl:text-[14px]")} text-[rgba(241,246,251,0.65)] cursor-pointer hover:underline`}>{t('t329')}</p>
                            <p onClick={handleClickOpen} className={`text-left mt-[5px] ${i18n.language === "en" ? "text-[14px] 2xl:text-[16px]" : (i18n.language === "si" ? "text-[12px] 2xl:text-[16px]" : "text-[11px] 2xl:text-[14px]")} text-[rgba(241,246,251,0.65)] cursor-pointer hover:underline`}>{t('t330')}</p>
                        </div>
                        <div className='flex flex-col items-start justify-start w-full'>
                            <p className={`text-left ${i18n.language === "en" ? "text-[18px] 2xl:text-[20px]" : (i18n.language === "si" ? "text-[15px] 2xl:text-[20px]" : "text-[13px] 2xl:text-[18px]")} text-[#F1F6FB] font-bold`}>{t('t340')}</p>
                            <p className={`text-left ${i18n.language === "en" ? "text-[13px] 2xl:text-[16px]" : (i18n.language === "si" ? "text-[12px] 2xl:text-[14px]" : "text-[11px] 2xl:text-[14px]")} text-[rgba(241,246,251,0.65)] mt-[20px]`}>{t('t341')}</p>
                            <p className={`text-left ${i18n.language === "en" ? "text-[13px] 2xl:text-[16px]" : (i18n.language === "si" ? "text-[12px] 2xl:text-[14px]" : "text-[11px] 2xl:text-[14px]")} text-[rgba(241,246,251,0.65)] `}>{t('t342')}</p>
                            <div className="w-[300px] 2xl:w-[450px] items-center mt-[20px] flex rounded-md bg-transparent pl-[10px] pr-[20px] h-[40px] 2xl:h-[50px] outline outline-1 -outline-offset-1 outline-[#F2AC0E] focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:[#F2AC0E]">
                                <input type="email" name="email"
                                    className={`ml-[10px] mr-[10px] w-full bg-transparent text-[#F2AC0E] ${i18n.language === "en" ? "text-[13px] 2xl:text-[15px]" : (i18n.language === "si" ? "text-[9px] 2xl:text-[14px]" : "text-[9px] 2xl:text-[14px]")} placeholder:text-[#F2AC0E] focus:outline focus:outline-0`} placeholder={t('t343')}
                                />
                                <MdArrowForward color='#F2AC0E' size={25} className='cursor-pointer' />
                            </div>
                            <p className={`text-left ${i18n.language === "en" ? "text-[11px] 2xl:text-[14px]" : (i18n.language === "si" ? "text-[9px] 2xl:text-[11px]" : "text-[9px] 2xl:text-[11px]")} text-[rgba(241,246,251,0.65)] mt-[10px]`}>{t('t344')} </p>
                            <p className={`text-left ${i18n.language === "en" ? "text-[11px] 2xl:text-[14px]" : (i18n.language === "si" ? "text-[9px] 2xl:text-[11px]" : "text-[9px] 2xl:text-[11px]")} text-[rgba(241,246,251,0.65)] `}>{t('t345')}</p>
                        </div>
                    </div>
                </div>
                <div className={`hidden ${showLoadingIndicator ? "none" : "xl:flex"} h-[30px] 2xl:h-[40px] w-screen bg-[#FAC236]  justify-center items-center bottom-0 px-[20px]`}>
                    <MdCopyright className='mr-[3px] text-[14px]' />
                    <p className='font-urban text-black text-[10px] 2xl:text-[12px] font-bold flex items-center justify-center mr-[3px]'>2025</p>
                    <p className='text-black text-[10px] 2xl:text-[12px] font-bold flex items-center justify-center mr-[3px]'>{t('t346')}</p>
                    <p className={`text-black text-[10px] 2xl:text-[12px] font-bold`}>Powered By <span className="relative cursor-pointer font-bold group" onClick={() => window.open('https://protonest.co/', '_blank')}>
                        Protonest
                        <span
                            className="absolute left-0 bottom-0 h-0.5 w-0 bg-black transition-all duration-300 group-hover:w-full"
                        ></span>
                    </span></p>
                </div>



                {/* this is the border of the xl and mobile view */}



                <div className={`${showLoadingIndicator ? "hidden" : 'w-screen '}`}>

                    <div className={`xl:hidden flex flex-col justify-center items-center h-full pt-[100px]`}>
                        <img src="/images/logo.svg" className="h-[130px] lg:h-[170px]" alt='logo' />
                        <p className={`text-center ${i18n.language === "en" ? "text-[35px] md:text-[55px] lg:text-[70px]" : (i18n.language === "si" ? "text-[25px] md:text-[40px] lg:text-[50px]" : "text-[18px] md:text-[35px] lg:text-[45px]")} mt-[10px]`}>{t('t1')}</p>
                        <p className={`text-center ${i18n.language === "en" ? "text-[16px] md:text-[21px] lg:text-[28px]" : (i18n.language === "si" ? "text-[14px] md:text-[21px] lg:text-[28px]" : "text-[13px] md:text-[20px] lg:text-[27px]")}`}>{t('t294')}</p>

                        <p className={`text-center ${i18n.language === "en" ? "text-[17px] md:text-[28px] lg:text-[35px]" : (i18n.language === "si" ? "text-[14px] md:text-[24px] lg:text-[30px]" : "text-[13px] md:text-[22px] lg:text-[28px]")}  font-bold pt-[30px] md:pt-[60px]`}>{t('t295')} <br />{t('t296')} </p>



                        {/* <p className='text-center mt-[20px] md:mt-[40px] text-[20px] md:text-[28px] lg:text-[32px] font-bold'>{t('t299')}</p> */}

                        <div className='flex items-center justify-center px-[20px] text-center w-full gap-[10px]'>
                            <button onClick={() => navigate('/user/boarding')} className={`flex items-center justify-center h-[50px] md:h-[60px] lg:h-[70px] py-[10px] md:py-[15px] lg:py-[17px] w-[45%] md:w-[250px] lg:w-[300px] ${i18n.language === "en" ? "text-[15px] md:text-[20px] lg:text-[26px]" : (i18n.language === "si" ? "text-[15px] md:text-[20px] lg:text-[26px]" : "text-[13px] md:text-[20px] lg:text-[26px]")}  mt-[10px] text-white font-bold rounded-xl bg-[#EFAE03] `}>{t('t446')}</button>
                            <button onClick={() => {
                                setVideoLangError(false);
                                setOpenVideoLangDialog(true);
                            }} className={`h-[50px] md:h-[60px] lg:h-[70px] gap-[10px] flex items-center justify-center py-[10px] md:py-[15px] lg:py-[25px] w-[45%] md:w-[250px] lg:w-[300px] ${i18n.language === "en" ? "text-[15px] md:text-[20px] lg:text-[26px]" : (i18n.language === "si" ? "text-[15px] md:text-[20px] lg:text-[26px]" : "text-[13px] md:text-[20px] lg:text-[26px]")}  mt-[10px] text-[#CE8500] font-bold rounded-xl bg-transparent border border-[#EFAE03] border-[2px] `}>
                                <MdOutlineVideocam size={30} className='text-[#CE8500]' />
                                {t('t447')}
                            </button>
                            {/* <p className='text-black mt-[10px] text-[14px] md:text-[20px] lg:text-[26px]'>{t('t8')} <span className='text-[#FDC50C] font-bold'>{t('t9')}</span></p> */}
                        </div>

                        <div className='p-[20px] md:p-[30px] flex flex-col justify-center items-start rounded-2xl mt-[30px] md:mt-[50px] mx-[10px] md:mx-[100px] lg:mx-[150px] bg-[#F2AC0E] bg-opacity-20 min-h-[200px] border border-[#F2AC0E] border-[2px] md:border-[3px]'>
                            <p className='font-bold text-[18px] md:text-[23px] lg:text-[30px]'>{t('t297')}</p>
                            <p className='pt-[10px] md:pt-[20px] text-[15px] md:text-[20px] lg:text-[26px]'>{t('t298')} </p>
                        </div>

                        <div className='w-full md:flex items-center justify-center'>
                            <div className='mt-[30px] bg-[#FAC236] rounded-xl mx-[10px] px-[20px] py-[20px] bg-opacity-20 border border-[#FAC236] border-[2px] md:w-[600px] lg:w-[730px] '>
                                <div className='flex flex-col items-start justify-center'>
                                    <p className='text-black font-bold text-[17px] md:text-[27px] lg:text-[28px] '>{t('t300')}</p>
                                    <p className='text-black font-bold text-[17px] md:text-[23px] lg:text-[22px] mt-[10px]'>🎓 {t('t301')}</p>
                                </div>
                                <div >
                                    <p className='text-[#323B49] text-[15px] md:text-[24px]  pt-[10px] '>{t('t302')} <span className='font-bold'>{totalSchools}</span></p>
                                    <p className='text-[#323B49] text-[15px] md:text-[24px] pt-[3px]'>{t('t303')} <span className='font-bold'>{totalStudent}</span></p>
                                    <p className='text-[#323B49] text-[15px] md:text-[24px]  pt-[3px] pb-[5px]'>{t('t304')} <span className='font-bold'>{totalTeacher}</span></p>
                                </div>
                                <div className='h-[300px] w-full mt-[20px]'>
                                    <GoogleMapReact
                                        bootstrapURLKeys={{ key: "AIzaSyB_TkkxZRCk_V6-k1nfYm-jhfvWNdGG2SA" }}
                                        defaultCenter={defaultProps.center}
                                        defaultZoom={defaultProps.zoom}
                                    >
                                        {locations.map((location, index) => (
                                            <Marker
                                                key={index}
                                                lat={location.lat}
                                                lng={location.lng}
                                                text={location.s_name}
                                            />
                                        ))}
                                    </GoogleMapReact>
                                </div>
                            </div>
                        </div>

                        <div className='xl:hidden flex flex-col justify-center items-center mt-[20px] md:mt-[30px] lg:mt-[40px] mb-[10px] text-center'>
                            <p className={`font-bold  ${i18n.language === "en" ? "text-[16px] md:text-[20px] lg:text-[26px]" : (i18n.language === "si" ? "text-[13px] md:text-[24px] lg:text-[25px]" : "text-[14px] md:text-[24px] lg:text-[25px]")} `}>{t('t305')}</p>
                        </div>

                        <div className='xl:hidden w-[90%]' >
                            <Carousel autoPlay={true} infiniteLoop showThumbs={false} showStatus={false} centerMode showArrows={false}
                                centerSlidePercentage={window.innerWidth < 768 ? 100 : 50}
                                transitionTime={500}
                            >
                                <div className='min-h-[250px] md:min-h-[300px] rounded-xl mt-[10px] mb-[30px] mx-[10px] flex flex-col items-center justify-center border border-[#FAC236] border-[2px] pt-[10px] md:pt-[15px] lg:pt-[20px] pb-[20px]'>
                                    <img src="images/r_img1.png" alt="Naveen" style={{ width: "150px", height: "150px", borderRadius: "50%", objectFit: "cover" }} />
                                    <div className="flex flex-col">
                                        <p className=' text-[14px] md:text-[20px] lg:text-[26px] font-bold'>Naveen Wickremeratne</p>
                                        <p className=' text-[13px] md:text-[17px] lg:text-[23px]'>Monash University, Australia</p>
                                    </div>
                                </div>
                                <div className='min-h-[250px] md:min-h-[300px] rounded-xl mt-[10px] mb-[30px] mx-[10px] flex flex-col items-center justify-center border border-[#FAC236] border-[2px] pt-[10px] pb-[20px]'>
                                    <img src="images/r_img4.jpg" alt="Andreas Pondorfer" style={{ width: "150px", height: "150px", borderRadius: "50%", objectFit: "cover" }} />
                                    <div className="flex flex-col">
                                        <p className=' text-[14px] md:text-[20px] lg:text-[26px] font-bold'>Andreas Pondorfer</p>
                                        <p className=' text-[13px] md:text-[17px] lg:text-[23px]'>Technical University of Munich, Germany</p>
                                    </div>
                                </div>
                                <div className='min-h-[250px] md:min-h-[300px] rounded-xl mt-[10px] mb-[30px] mx-[10px] flex flex-col items-center justify-center border border-[#FAC236] border-[2px] pt-[10px] pb-[10px] md:px-[3px]'>
                                    <img src="images/r_img6.jpg" alt="Person 1" style={{ width: "150px", height: "150px", borderRadius: "50%", objectFit: "cover" }} />
                                    <div className="flex flex-col">
                                        <p className=' text-[14px] md:text-[20px] lg:text-[26px] font-bold'>Matthias Sutter</p>
                                        <p className=' text-[13px] md:text-[17px] lg:text-[23px]'>Max Planck Institute for Research on Collective Goods, Germany </p>
                                    </div>
                                </div>
                                <div className='min-h-[250px] md:min-h-[300px] rounded-xl mt-[10px] mb-[30px] mx-[10px] flex flex-col items-center justify-center border border-[#FAC236] border-[2px] pt-[10px] pb-[20px]'>
                                    <img src="images/r_img2.jpg" alt="Bandula Thrimavithana" style={{ width: "150px", height: "150px", borderRadius: "50%", objectFit: "cover" }} />
                                    <div className="flex flex-col">
                                        <p className=' text-[14px] md:text-[20px] lg:text-[26px] font-bold'>Bandula Thrimavithana</p>
                                        <p className=' text-[13px] md:text-[17px] lg:text-[23px]'>Center for Social Change (CSC), Sri Lanka</p>
                                    </div>
                                </div>
                                <div className='min-h-[250px] md:min-h-[300px] rounded-xl mt-[10px] mb-[30px] mx-[10px] flex flex-col items-center justify-center border border-[#FAC236] border-[2px] pt-[10px] pb-[20px]'>
                                    <img src="images/r_img5.jpg" alt="Thusitha Siriwardana" style={{ width: "150px", height: "150px", borderRadius: "50%", objectFit: "cover" }} />
                                    <div className="flex flex-col">
                                        <p className=' text-[14px] md:text-[20px] lg:text-[26px] font-bold'>Thusitha Siriwardana</p>
                                        <p className=' text-[13px] md:text-[17px] lg:text-[23px]'>Center for Social Change (CSC), Sri Lanka</p>
                                    </div>
                                </div>
                                <div className='min-h-[250px] md:min-h-[300px] rounded-xl mt-[10px] mb-[30px] mx-[10px] flex flex-col items-center justify-center border border-[#FAC236] border-[2px] pt-[10px] pb-[20px]'>
                                    <img src="images/r_img3.png" alt="Person 1" style={{ width: "150px", height: "150px", borderRadius: "50%", objectFit: "cover" }} />
                                    <div className="flex flex-col">
                                        <p className=' text-[14px] md:text-[20px] lg:text-[26px] font-bold'>Nuwan Walasmullage</p>
                                        <p className=' text-[13px] md:text-[17px] lg:text-[23px]'>Social Vision Survey Institute, Sri Lanka</p>
                                    </div>
                                </div>
                            </Carousel>
                        </div>
                    </div>

                    <div className='xl:hidden mt-[30px] flex flex-col justify-center items-center pt-[10px] pb-[20px] bg-[#FAC236] w-screen'>
                        <div className='mb-[20px]'>
                            <p className={`font-bold ${i18n.language === "en" ? "text-[16px] md:text-[20px] lg:text-[26px]" : (i18n.language === "si" ? "text-[13px] md:text-[24px] lg:text-[25px]" : "text-[14px] md:text-[24px] lg:text-[25px]")}`}>{t('t306')}</p>
                        </div>
                        <div>
                            <Slider
                                width="200px"
                                duration={10}
                                pauseOnHover={true}
                                blurBorders={false}
                                blurBorderColor={'#fff'}
                            >
                                <Slider.Slide>
                                    <div className='mr-[20px]'>
                                        <img src="images/logo_1.png" alt="any" className='h-[60px] ' />
                                    </div>
                                </Slider.Slide>
                                <Slider.Slide>
                                    <div className='ml-[30px]'>
                                        <img src="images/protonest.png" alt="any" className='h-[58px] ' />
                                    </div>
                                </Slider.Slide>
                                <Slider.Slide>
                                    <div className='mx-[30px]'>
                                        <img src="images/logo_2.png" alt="any" className='h-[55px] ' />
                                    </div>
                                </Slider.Slide>
                                <Slider.Slide>
                                    <div className='mx-[30px]'>
                                        <img src="images/logo_3.png" alt="any" className='h-[55px] ' />
                                    </div>
                                </Slider.Slide>
                            </Slider>
                        </div>
                    </div>

                    <div className='xl:hidden flex flex-col justify-center items-center mt-[20px] md:mt-[30px] lg:mt-[40px]'>
                        <p className='font-bold text-[16px] md:text-[20px] lg:text-[26px]'>{t('t307')}</p>
                    </div>

                    <div className='md:hidden'>
                        <Carousel autoPlay={true} infiniteLoop showThumbs={false} showStatus={false} centerMode showArrows={false} showIndicators={false}
                            centerSlidePercentage={window.innerWidth < 768 ? 50 : 25}
                            transitionTime={500}
                        >
                            <div className=' mx-[10px] lg:mx-[40px] rounded-xl mt-[10px] mb-[30px] pt-[10px] pb-[20px]'>
                                <img src="images/imc4.png" alt="Person 1" style={{ width: "200px", height: "auto" }} />
                            </div>

                            <div className=' mx-[10px] lg:mx-[40px] rounded-xl mt-[10px] mb-[30px]  pt-[10px] pb-[20px]'>
                                <img src="images/imc3.png" alt="Person 1" style={{ width: "200px", height: "auto" }} />
                            </div>

                            <div className='mx-[10px] lg:mx-[40px] rounded-xl mt-[10px] mb-[30px]  pt-[10px] pb-[20px]'>
                                <img src="images/imc4.png" alt="Person 1" style={{ width: "200px", height: "auto" }} />
                            </div>

                            <div className='mx-[10px] lg:mx-[40px] rounded-xl mt-[10px] mb-[30px]  pt-[10px] pb-[20px]'>
                                <img src="images/imc3.png" alt="Person 1" style={{ width: "200px", height: "auto" }} />
                            </div>

                            <div className='mx-[10px] lg:mx-[40px] rounded-xl mt-[10px] mb-[30px] pt-[10px] pb-[20px]'>
                                <img src="images/imc4.png" alt="Person 1" style={{ width: "200px", height: "auto" }} />
                            </div>

                            <div className='mx-[10px] lg:mx-[40px] rounded-xl mt-[10px] mb-[30px] pt-[10px] pb-[20px]'>
                                <img src="images/imc3.png" alt="Person 1" style={{ width: "200px", height: "auto" }} />
                            </div>
                        </Carousel>
                    </div>

                    <div className='hidden md:block xl:hidden '>
                        <Carousel autoPlay={true} infiniteLoop={true} showThumbs={false} showStatus={false} centerMode showArrows={false} showIndicators={false}
                            centerSlidePercentage={window.innerWidth < 768 ? 50 : 50}
                            transitionTime={500}
                        >
                            <div className='md:mx-[20px] lg:mx-[0px] rounded-xl mt-[10px] mb-[30px] pt-[10px] pb-[20px]'>
                                <img src="images/imc4.png" alt="Person 1" style={{ height: "400px", width: "auto" }} />
                            </div>

                            <div className='md:mx-[20px] lg:mx-[0px] rounded-xl mt-[10px] mb-[30px]  pt-[10px] pb-[20px]'>
                                <img src="images/imc3.png" alt="Person 1" style={{ height: "400px", width: "auto" }} />
                            </div>

                            <div className='md:mx-[20px] lg:mx-[0px] rounded-xl mt-[10px] mb-[30px]  pt-[10px] pb-[20px]'>
                                <img src="images/imc4.png" alt="Person 1" style={{ height: "400px", width: "auto" }} />
                            </div>

                            <div className='md:mx-[20px] lg:mx-[0px] rounded-xl mt-[10px] mb-[30px]  pt-[10px] pb-[20px]'>
                                <img src="images/imc3.png" alt="Person 1" style={{ height: "400px", width: "auto" }} />
                            </div>

                            <div className='mx-[20px] rounded-xl mt-[10px] mb-[30px] pt-[10px] pb-[20px]'>
                                <img src="images/imc4.png" alt="Person 1" style={{ height: "400px", width: "auto" }} />
                            </div>

                            <div className='mx-[20px] rounded-xl mt-[10px] mb-[30px] pt-[10px] pb-[20px]'>
                                <img src="images/imc3.png" alt="Person 1" style={{ height: "400px", width: "auto" }} />
                            </div>
                        </Carousel>
                    </div>

                    <div className='flex flex-col justify-center items-center w-screen'>
                        <div className='xl:hidden bg-[#FAC236] rounded-xl mx-[20px] px-[20px] py-[20px] bg-opacity-20 border border-[#FAC236] border-[2px] w-[90%] md:w-[600px] lg:w-[730px] '>
                            <div className='flex items-center justify-start'>
                                <p className='text-black font-bold text-[17px] md:text-[27px] lg:text-[28px] pl-[10px]'>📊 {t('t308')}</p>
                            </div>
                            <div >
                                <p className={`${i18n.language === "en" ? "text-[13px] md:text-[27px] lg:text-[28px]" : (i18n.language === "si" ? "text-[13px] md:text-[27px] lg:text-[28px]" : "text-[12px] md:text-[22px] lg:text-[28px]")} text-black pt-[20px] pb-[5px]`}>{t('t309')} {districtSchool.western[0]} {t('t318')} ({districtSchool.western[1]}%) <br /> {districtSchool.western[2]} {districtSchool.western[2] > 1 ? t('t33_1') : t('t33')}</p>
                                <progress value={districtSchool.western[1]} max={100} className='w-full custom-progress-bar' />
                            </div>
                            <div >
                                <p className={`${i18n.language === "en" ? "text-[13px] md:text-[27px] lg:text-[28px]" : (i18n.language === "si" ? "text-[13px] md:text-[27px] lg:text-[28px]" : "text-[12px] md:text-[22px] lg:text-[28px]")} text-black pt-[20px] pb-[5px]`}>{t('t310')} {districtSchool.eastern[0]} {t('t318')} ({districtSchool.eastern[1]}%) <br /> {districtSchool.eastern[2]} {districtSchool.eastern[2] > 1 ? t('t33_1') : t('t33')}</p>
                                <progress value={districtSchool.eastern[1]} max={100} className='w-full custom-progress-bar' />
                            </div>
                            <div >
                                <p className={`${i18n.language === "en" ? "text-[13px] md:text-[27px] lg:text-[28px]" : (i18n.language === "si" ? "text-[13px] md:text-[27px] lg:text-[28px]" : "text-[12px] md:text-[22px] lg:text-[28px]")} text-black pt-[20px] pb-[5px]`}>{t('t311')} {districtSchool.northern[0]} {t('t318')} ({districtSchool.northern[1]}%) <br /> {districtSchool.northern[2]} {districtSchool.northern[2] > 1 ? t('t33_1') : t('t33')}</p>
                                <progress value={districtSchool.northern[1]} max={100} className='w-full custom-progress-bar' />
                            </div>
                            <div >
                                <p className={`${i18n.language === "en" ? "text-[13px] md:text-[27px] lg:text-[28px]" : (i18n.language === "si" ? "text-[13px] md:text-[27px] lg:text-[28px]" : "text-[12px] md:text-[22px] lg:text-[28px]")} text-black pt-[20px] pb-[5px]`}>{t('t312')} {districtSchool.southern[0]} {t('t318')} ({districtSchool.southern[1]}%) <br /> {districtSchool.southern[2]} {districtSchool.southern[2] > 1 ? t('t33_1') : t('t33')}</p>
                                <progress value={districtSchool.southern[1]} max={100} className='w-full custom-progress-bar' />
                            </div>
                            <div >
                                <p className={`${i18n.language === "en" ? "text-[13px] md:text-[27px] lg:text-[28px]" : (i18n.language === "si" ? "text-[13px] md:text-[27px] lg:text-[28px]" : "text-[12px] md:text-[22px] lg:text-[28px]")} text-black pt-[20px] pb-[5px]`}>{t('t313')} {districtSchool.central[0]} {t('t318')} ({districtSchool.central[1]}%) <br /> {districtSchool.central[2]} {districtSchool.central[2] > 1 ? t('t33_1') : t('t33')}</p>
                                <progress value={districtSchool.central[1]} max={100} className='w-full custom-progress-bar' />
                            </div>
                            <div >
                                <p className={`${i18n.language === "en" ? "text-[13px] md:text-[27px] lg:text-[28px]" : (i18n.language === "si" ? "text-[13px] md:text-[27px] lg:text-[28px]" : "text-[12px] md:text-[22px] lg:text-[28px]")} text-black pt-[20px] pb-[5px]`}>{t('t314')} {districtSchool.northCentral[0]} {t('t318')} ({districtSchool.northCentral[1]}%) <br /> {districtSchool.northCentral[2]} {districtSchool.northCentral[2] > 1 ? t('t33_1') : t('t33')}</p>
                                <progress value={districtSchool.northCentral[1]} max={100} className='w-full custom-progress-bar' />
                            </div>
                            <div >
                                <p className={`${i18n.language === "en" ? "text-[13px] md:text-[27px] lg:text-[28px]" : (i18n.language === "si" ? "text-[13px] md:text-[27px] lg:text-[28px]" : "text-[12px] md:text-[22px] lg:text-[28px]")} text-black pt-[20px] pb-[5px]`}>{t('t315')} {districtSchool.northWestern[0]} {t('t318')} ({districtSchool.northWestern[1]}%) <br /> {districtSchool.northWestern[2]} {districtSchool.northWestern[2] > 1 ? t('t33_1') : t('t33')}</p>
                                <progress value={districtSchool.northWestern[1]} max={100} className='w-full custom-progress-bar' />
                            </div>
                            <div >
                                <p className={`${i18n.language === "en" ? "text-[13px] md:text-[27px] lg:text-[28px]" : (i18n.language === "si" ? "text-[13px] md:text-[27px] lg:text-[28px]" : "text-[12px] md:text-[22px] lg:text-[28px]")} text-black pt-[20px] pb-[5px]`}>{t('t316')} {districtSchool.uva[0]} {t('t318')} ({districtSchool.uva[1]}%) <br /> {districtSchool.uva[2]} {districtSchool.uva[2] > 1 ? t('t33_1') : t('t33')}</p>
                                <progress value={districtSchool.uva[1]} max={100} className='w-full custom-progress-bar' />
                            </div>
                            <div >
                                <p className={`${i18n.language === "en" ? "text-[13px] md:text-[27px] lg:text-[28px]" : (i18n.language === "si" ? "text-[13px] md:text-[27px] lg:text-[28px]" : "text-[12px] md:text-[22px] lg:text-[28px]")} text-black pt-[20px] pb-[5px]`}>{t('t317')} {districtSchool.sabaragamuwa[0]} {t('t318')} ({districtSchool.sabaragamuwa[1]}%) <br /> {districtSchool.sabaragamuwa[2]} {districtSchool.sabaragamuwa[2] > 1 ? t('t33_1') : t('t33')}</p>
                                <progress value={districtSchool.sabaragamuwa[1]} max={100} className='w-full custom-progress-bar' />
                            </div>
                        </div>

                        <div className='xl:hidden mt-[30px] bg-[#FAC236] rounded-xl mx-[20px] px-[20px] py-[20px] bg-opacity-20 border border-[#FAC236] border-[2px] w-[90%] md:w-[600px] lg:w-[730px] '>
                            <div className='flex items-center justify-start'>
                                <p className='text-black font-bold text-[17px] md:text-[27px] lg:text-[28px] pl-[10px]'>📧 {t('t319')}</p>
                            </div>
                            <div >
                                <p className={`text-[#323B49] ${i18n.language === "en" ? "text-[15px] md:text-[27px] lg:text-[28px]" : (i18n.language === "si" ? "text-[12px] md:text-[23px] lg:text-[24px]" : "text-[13px] md:text-[22px] lg:text-[24px]")} pt-[20px] `}>{t('t320')} <span className='font-bold'>{letterDetails.totalLetters}</span></p>
                                {/* <p className={`text-[#323B49] ${i18n.language === "en" ? "text-[15px] md:text-[27px] lg:text-[28px]" : (i18n.language === "si" ? "text-[12px] md:text-[23px] lg:text-[24px]" : "text-[13px] md:text-[22px] lg:text-[24px]")} pt-[5px]`}>{t('t321')} <span className='font-bold'>{letterDetails.averageWord}</span> {t('t323')}</p> */}
                                <p className={`text-[#323B49] ${i18n.language === "en" ? "text-[15px] md:text-[27px] lg:text-[28px]" : (i18n.language === "si" ? "text-[12px] md:text-[23px] lg:text-[24px]" : "text-[13px] md:text-[22px] lg:text-[24px]")} pt-[5px] pb-[5px]`}>{t('t322')} <span className='font-bold'>{letterDetails.totalWords}</span> {t('t323')}</p>
                            </div>
                        </div>

                        <div className='xl:hidden mt-[30px] bg-[#FAC236] rounded-xl mx-[20px] px-[20px] py-[20px] bg-opacity-20 border border-[#FAC236] border-[2px] w-[90%] md:w-[600px] lg:w-[730px] '>
                            <div className='flex items-center justify-start'>
                                <p className='text-black font-bold text-[17px] md:text-[27px] lg:text-[28px] pl-[10px]'>💬 {t('t324')}</p>
                            </div>
                            <div className='flex justify-evenly items-center mt-[20px]'>
                                <div className='flex flex-col items-center justify-center'>
                                    <img src='images/positive.svg' alt='positive' className='h-[70px] md:h-[90px]' />
                                    <p className={`text-black ${i18n.language === "en" ? "text-[17px] md:text-[24px] lg:text-[25px]" : (i18n.language === "si" ? "text-[13px] md:text-[24px] lg:text-[25px]" : "text-[13px] md:text-[24px] lg:text-[25px]")}  mt-[5px] font-bold`}>{t('t325')}</p>
                                    <p className='text-black text-[17px] md:text-[24px] lg:text-[25px]'>{sentiment.positive} %</p>
                                </div>
                                <div className='flex flex-col items-center justify-center'>
                                    <img src='images/negative.svg' alt='negative' className='h-[70px] md:h-[90px]' />
                                    <p className={`text-black ${i18n.language === "en" ? "text-[17px] md:text-[24px] lg:text-[25px]" : (i18n.language === "si" ? "text-[13px] md:text-[24px] lg:text-[25px]" : "text-[13px] md:text-[24px] lg:text-[25px]")} mt-[5px] font-bold`}>{t('t326')}</p>
                                    <p className='text-black text-[17px] md:text-[24px] lg:text-[25px]'>{sentiment.negative} %</p>
                                </div>
                                <div className='flex flex-col items-center justify-center'>
                                    <img src='images/neutral.svg' alt='neutral' className='h-[70px] md:h-[90px]' />
                                    <p className={`text-black ${i18n.language === "en" ? "text-[17px] md:text-[24px] lg:text-[25px]" : (i18n.language === "si" ? "text-[13px] md:text-[24px] lg:text-[25px]" : "text-[13px] md:text-[24px] lg:text-[25px]")} mt-[5px] font-bold`}>{t('t327')}</p>
                                    <p className='text-black text-[17px] md:text-[24px] lg:text-[25px]'>{sentiment.neutral} %</p>
                                </div>
                            </div>
                        </div>

                        <div className='xl:hidden flex justify-center items-center mt-[40px] md:mt-[80px] lg:mt-[100px] px-[10px] mb-[10px]'>
                            <div className='flex items-center justify-center ' onClick={handleClickOpen3}>
                                <p className={`hover:underline text-[#F2AC0E] text-center ${i18n.language === "en" ? "text-[15px] md:text-[20px] lg:text-[24px]" : (i18n.language === "si" ? "text-[12px] md:text-[20px] lg:text-[22px]" : "text-[11px] md:text-[17px] lg:text-[19px]")} `}>{t('t328')}</p>
                                <p className='ml-[1px] mr-[1px] md:ml-[3px] md:mr-[3px] text-[#F2AC0E]'>|</p>
                            </div>
                            <div className='flex items-center justify-center' onClick={handleClickOpen2}>
                                <p className={`hover:underline text-[#F2AC0E] text-center ${i18n.language === "en" ? "text-[15px] md:text-[20px] lg:text-[24px]" : (i18n.language === "si" ? "text-[12px] md:text-[20px] lg:text-[22px]" : "text-[11px] md:text-[17px] lg:text-[19px]")}`}>{t('t329')}</p>
                                <p className='ml-[1px] mr-[1px] md:ml-[3px] md:mr-[3px] text-[#F2AC0E]'>|</p>
                            </div>
                            <div className='flex items-center justify-center text-center' onClick={handleClickOpen}>
                                <p className={`hover:underline text-[#F2AC0E] ${i18n.language === "en" ? "text-[15px] md:text-[20px] lg:text-[24px]" : (i18n.language === "si" ? "text-[12px] md:text-[20px] lg:text-[22px]" : "text-[11px] md:text-[17px] lg:text-[19px]")}`}>{t('t330')}</p>
                            </div>
                        </div>
                        <div className={`xl:hidden flex h-[30px] 2xl:h-[40px] w-screen bg-[#FAC236]  justify-center items-center bottom-0 `}>
                            <MdCopyright className='mr-[3px] text-[14px]' />
                            <p className='font-urban text-black text-[10px] 2xl:text-[12px] font-bold flex items-center justify-center mr-[3px]'>2025</p>
                            <p className={`text-black ${i18n.language === "en" ? "text-[10px]" : (i18n.language === "si" ? "text-[9px]" : "text-[8px] ")} font-bold flex items-center justify-center mr-[3px]`}>{t('t346')}</p>
                            <p className={`text-black text-[10px] font-bold`}>Powered By <span className="relative cursor-pointer font-bold group" onClick={() => window.open('https://protonest.co/', '_blank')}>
                                Protonest
                                <span
                                    className="absolute left-0 bottom-0 h-0.5 w-0 bg-black transition-all duration-300 group-hover:w-full"
                                ></span>
                            </span></p>
                        </div>
                    </div>
                </div>

                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="custom-dialog-title"
                    aria-describedby="custom-dialog-description"
                    className="backdrop-blur-sm"
                >
                    <DialogTitle
                        id="custom-dialog-title"
                        className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                    >
                        {t('t53')}
                    </DialogTitle>
                    <DialogContent className="bg-gray-50">
                        <p className='mt-[20px] text-black'>{t('t394')}</p>
                        <p className='mt-[20px] text-black'>{t('t395')}</p>
                        <p className='ml-[20px] text-black'>{t('t396')}</p>
                        <p className='mt-[20px] text-black'>{t('t397')}</p>
                        <p className='ml-[20px] text-black'>{t('t398')}</p>
                        <p className='mt-[20px] text-black'>{t('t399')}</p>
                        <p className='ml-[20px] text-black'>{t('t400')}</p>
                        <p className='mt-[20px] text-black'>{t('t401')}</p>
                        <p className='ml-[20px] text-black'>{t('t402')}</p>
                        <p className='mt-[20px] mb-[20px] text-black'>{t('t403')}</p>

                    </DialogContent>
                    <DialogActions className="px-4 py-2">
                        <Button
                            onClick={handleClose}
                            className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                            style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                        >
                            {t('t13')}
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={open2}
                    onClose={handleClose2}
                    aria-labelledby="custom-dialog-title"
                    aria-describedby="custom-dialog-description"
                    className="backdrop-blur-sm"
                >
                    <DialogTitle
                        id="custom-dialog-title"
                        className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                    >
                        {t('t329')}
                    </DialogTitle>
                    <DialogContent className="bg-gray-50">
                        <div className='flex flex-col justify-center items-start pl-[10px] pr-[2px] pb-[20px]'>
                            <p className='mt-[20px] text-black font-bold text-[15px] md:text-[17px] lg:text-[19px] xl:text-[18px] 2xl:text-[19px] underline'>{t('t363')}</p>
                            <p className='mt-[5px] text-black text-[15px] md:text-[17px] lg:text-[19px] xl:text-[18px] 2xl:text-[19px]'>{t('t364')}</p>
                            <p className='mt-[20px] text-black font-bold text-[15px] md:text-[17px] lg:text-[19px] xl:text-[18px] 2xl:text-[19px] underline'>{t('t365')}</p>
                            <p className='mt-[5px] text-black text-[15px] md:text-[17px] lg:text-[19px] xl:text-[18px] 2xl:text-[19px]'>{t('t366')}</p>
                            <ul style={{ listStyleType: "disc", paddingLeft: "20px" }} className='mt-[5px] ml-[20px] text-black text-[15px] md:text-[17px] lg:text-[19px] xl:text-[18px] 2xl:text-[19px]'>
                                <li>{t('t367')}</li>
                                <li>{t('t368')}</li>
                                <li>{t('t369')}</li>
                            </ul>
                            <p className='mt-[20px] text-black font-bold text-[15px] md:text-[17px] lg:text-[19px] xl:text-[18px] 2xl:text-[19px] underline'>{t('t370')}</p>
                            <ul style={{ listStyleType: "disc", paddingLeft: "20px" }} className='mt-[5px] ml-[20px] text-black text-[15px] md:text-[17px] lg:text-[19px] xl:text-[18px] 2xl:text-[19px]'>
                                <li>{t('t371')}</li>
                                <li>{t('t372')}</li>
                                <li>{t('t373')}</li>
                            </ul>
                            <p className='mt-[20px] text-black font-bold text-[15px] md:text-[17px] lg:text-[19px] xl:text-[18px] 2xl:text-[19px] underline'>{t('t374')}</p>
                            <ul style={{ listStyleType: "disc", paddingLeft: "20px" }} className='mt-[5px] ml-[20px] text-black text-[15px] md:text-[17px] lg:text-[19px] xl:text-[18px] 2xl:text-[19px]'>
                                <li>{t('t375')}</li>
                                <li>{t('t376')}</li>
                                <li>{t('t377')}</li>
                            </ul>
                            <p className='mt-[20px] text-black font-bold text-[15px] md:text-[17px] lg:text-[19px] xl:text-[18px] 2xl:text-[19px] underline'>{t('t378')}</p>
                            <ul style={{ listStyleType: "disc", paddingLeft: "20px" }} className='mt-[5px] ml-[20px] text-black text-[15px] md:text-[17px] lg:text-[19px] xl:text-[18px] 2xl:text-[19px]'>
                                <li>{t('t379')}</li>
                                <li>{t('t380')}</li>
                            </ul>
                        </div>

                    </DialogContent>
                    <DialogActions className="px-4 py-2">
                        <Button
                            onClick={handleClose2}
                            className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                            style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                        >
                            {t('t13')}
                        </Button>
                    </DialogActions>
                </Dialog>


                <Dialog
                    open={openError}
                    onClose={handleCloseError}
                    aria-labelledby="custom-dialog-title"
                    aria-describedby="custom-dialog-description"
                    className="backdrop-blur-sm"
                >
                    <DialogTitle
                        id="custom-dialog-title"
                        className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                    >
                        {t('t95')}
                    </DialogTitle>
                    <DialogContent className="bg-gray-50">
                        <DialogContentText
                            id="custom-dialog-description"
                            className="text-gray-600 text-md mt-2"
                        >
                            {error}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions className="px-4 py-2">
                        <Button
                            onClick={handleCloseError}
                            className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                            style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                        >
                            {t('t96')}
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={open3}
                    onClose={handleClose3}
                    aria-labelledby="custom-dialog-title"
                    aria-describedby="custom-dialog-description"
                    className="backdrop-blur-sm"
                >
                    <DialogTitle
                        id="custom-dialog-title"
                        className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                    >
                        {t('t328')}
                    </DialogTitle>
                    <DialogContent className="bg-gray-50">
                        <div className='flex flex-col justify-center items-start pl-[10px] pr-[2px] pb-[20px]'>
                            <p className='mt-[20px] text-black text-[15px] md:text-[17px] lg:text-[19px] xl:text-[18px] 2xl:text-[19px]'>{t('t406')} <span className='hover:underline'><a href="mailto:bddivides@gmail.com">bddivides@gmail.com</a></span></p>
                            <p className='mt-[20px] text-black text-[15px] md:text-[17px] lg:text-[19px] xl:text-[18px] 2xl:text-[19px]'>{t('t407')} <span className='hover:underline'><a href="tel:+94771482755">0771482755</a></span></p>
                        </div>

                    </DialogContent>
                    <DialogActions className="px-4 py-2">
                        <Button
                            onClick={handleClose3}
                            className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                            style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                        >
                            {t('t13')}
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={openLangSelectInitial}
                    aria-labelledby="custom-dialog-title"
                    className="backdrop-blur-sm"
                >
                    <div className="bg-gray-50 px-6 pt-6 pb-3 rounded-lg w-full md:w-[300px]">
                        <RadioGroup
                            value={language}
                            onChange={(lang) => {
                                setVideoLangError(false);
                                setLanguage(lang);
                                changeLanguage(lang === "English" ? "en" : lang === "Sinhala" ? "si" : "ta");
                            }}
                        >
                            <RadioGroup.Label className="block text-[#686868] text-sm mb-4">
                                {t('t448')}
                            </RadioGroup.Label>

                            <div className="space-y-2">
                                {["English", "Sinhala", "Tamil"].map((lang) => (
                                    <RadioGroup.Option
                                        key={lang}
                                        value={lang}
                                        className={({ checked }) =>
                                            `relative flex cursor-pointer rounded-lg px-5 py-3 focus:outline-none transition-colors
                            ${checked ? 'bg-[#F2AC0E] text-white' : 'bg-white text-gray-900'}`
                                        }
                                    >
                                        {({ checked }) => (
                                            <div className="flex items-center justify-between w-full">
                                                <div className="flex items-center">
                                                    {/* Custom radio circle */}
                                                    <div className={`w-5 h-5 rounded-full border-2 mr-3 flex items-center justify-center 
                                        ${checked ? 'border-white' : 'border-gray-400'}`}
                                                    >
                                                        {checked && <div className="w-2.5 h-2.5 rounded-full bg-white"></div>}
                                                    </div>
                                                    <span className="text-sm font-medium">
                                                        {lang === "Sinhala" ? "සිංහල" : lang === "Tamil" ? "தமிழ்" : lang}
                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                    </RadioGroup.Option>
                                ))}
                            </div>
                        </RadioGroup>
                    </div>
                    <DialogActions className='w-full flex flex-col justify-center items-center'>
                        {
                            videoLangError && <p className='text-red-500 text-[14px] mt-[10px] mb-[10px]'>
                                {t('t32')}
                            </p>
                        }
                        <div className='w-full flex justify-center items-center gap-[10px] pb-[10px] 2xl:pb-[30px]'>
                            <Button
                                onClick={() => {
                                    setLanguage("English");
                                    setVideoLangError(false);
                                    setOpenLangSelectInitial(false);

                                }}
                                className=" px-4 py-2 rounded-md w-[43%] text-[16px]"
                                style={{ backgroundColor: 'transparent', color: '#FFCD2A', fontWeight: 'bold', border: '2px solid #FFCD2A' }}
                            >
                                {/* {t('t145')} */}
                                Cancel
                            </Button>
                            <Button
                                onClick={() => {
                                    if (language === "Sinhala" || language === "Tamil" || language === "English") {
                                        setVideoLangError(false);
                                        setOpenLangSelectInitial(false);
                                    } else {
                                        setVideoLangError(true);
                                    }

                                }}
                                className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md w-[43%]"
                                style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold', border: '2px solid #F2AC0E' }}
                            >
                                {/* {t('t13')} */}
                                Save
                            </Button>
                        </div>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={openVideoLangDialog}
                    aria-labelledby="custom-dialog-title"
                    className="backdrop-blur-sm"
                >
                    <div className="bg-gray-50 px-6 pt-6 pb-3 rounded-lg w-full md:w-[300px]">
                        <RadioGroup
                            value={videoLanguage}
                            onChange={(lang) => {
                                setVideoLanguage(lang);
                                setVideoLangError(false);
                            }}
                        >
                            <RadioGroup.Label className="block text-[#686868] text-sm mb-4">
                                {t('t449')}
                            </RadioGroup.Label>

                            <div className="space-y-2">
                                {["Sinhala", "Tamil"].map((lang) => (
                                    <RadioGroup.Option
                                        key={lang}
                                        value={lang}
                                        className={({ checked }) =>
                                            `relative flex cursor-pointer rounded-lg px-5 py-3 focus:outline-none transition-colors
                            ${checked ? 'bg-[#F2AC0E] text-white' : 'bg-white text-gray-900'}`
                                        }
                                    >
                                        {({ checked }) => (
                                            <div className="flex items-center justify-between w-full">
                                                <div className="flex items-center">
                                                    {/* Custom radio circle */}
                                                    <div className={`w-5 h-5 rounded-full border-2 mr-3 flex items-center justify-center 
                                        ${checked ? 'border-white' : 'border-gray-400'}`}
                                                    >
                                                        {checked && <div className="w-2.5 h-2.5 rounded-full bg-white"></div>}
                                                    </div>
                                                    <span className="text-sm font-medium">
                                                        {lang === "Sinhala" ? "සිංහල" : lang === "Tamil" ? "தமிழ்" : lang}
                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                    </RadioGroup.Option>
                                ))}
                            </div>
                        </RadioGroup>
                    </div>
                    <DialogActions className='w-full flex-col flex justify-center items-center'>
                        {
                            videoLangError && <p className='text-red-500 text-[14px] mt-[10px]'>
                                {t('t32')}
                            </p>
                        }
                        <div className='w-full flex justify-center items-center gap-[10px] pb-[10px] 2xl:pb-[30px]'>
                            <Button
                                onClick={() => {
                                    setVideoLanguage("");
                                    setVideoLangError(false);
                                    setOpenVideoLangDialog(false);
                                }}
                                className=" px-4 py-2 rounded-md w-[43%] text-[16px]"
                                style={{ backgroundColor: 'transparent', color: '#FFCD2A', fontWeight: 'bold', border: '2px solid #FFCD2A' }}
                            >
                                {t('t145')}
                            </Button>
                            <Button
                                onClick={() => {
                                    if (videoLanguage === "Sinhala" || videoLanguage === "Tamil") {
                                        setVideoLangError(false);
                                        setOpenVideoLangDialog(false);
                                        setOpenVideo(true);
                                    } else {
                                        setVideoLangError(true);
                                    }
                                }}
                                className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md w-[43%]"
                                style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold', border: '2px solid #F2AC0E' }}
                            >
                                {t('t7')}
                            </Button>

                        </div>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={openVideo}
                    aria-labelledby="custom-dialog-title"
                    aria-describedby="custom-dialog-description"
                    className="backdrop-blur-sm"
                >
                    <DialogContent className="bg-gray-50">
                        <div className="w-full aspect-video">
                            <video
                                className="w-full h-full rounded-md"
                                controls
                                autoPlay
                                controlsList="nodownload"
                                disablePictureInPicture
                                onContextMenu={(e) => e.preventDefault()}
                                src={videoLanguage === "Sinhala" ? videoUrlSinhala : videoUrlTamil}
                            >
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </DialogContent>

                    <DialogActions className="px-4 py-2">
                        <Button
                            onClick={handleCloseVideo}
                            className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                            style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                        >
                            {t('t13')}
                        </Button>
                    </DialogActions>
                </Dialog>

            </div>
        </>
    );
}

export default Homepage;